import Balloon from './Balloon'
import CopyEmail from './CopyEmail'
import EmailForm from './EmailForm'
import Clock from './Clock'
import Icon from './Icon'
import { Cloud } from './Drawings'
import avatar from '../images/avatar-blue.webp'
import { EMAIL, SOCIALS } from '../constants/site'

// The closing page: a night-harbour panel where Nikita asks to work together.
const Contact = () => (
  <footer id='contact' tabIndex={-1} className='mx-auto max-w-page scroll-mt-20 px-gutter pb-8 pt-section'>
    <div className='grid gap-tier lg:grid-cols-12'>
      <div className='panel overflow-hidden bg-sea text-paper lg:col-span-7 dark:text-ink'>
        <Cloud className='absolute right-[8%] top-[8%] hidden w-32 opacity-90 md:block' />
        <div className='relative flex h-full flex-col gap-10 p-5 pb-8 md:grid md:grid-cols-[auto_minmax(0,1fr)] md:items-center md:gap-10 md:p-[6%]'>
          <img
            src={avatar}
            alt=''
            width='400'
            height='400'
            loading='lazy'
            className='order-2 size-32 border-stroke border-line bg-paper object-cover sm:size-40 md:order-none md:size-48'
          />
          <div>
            <Balloon as='h2' tail='auto' className='w-fit max-w-[11ch] font-display uppercase text-h2 lg:text-[length:clamp(2.25rem,4vw,2.75rem)]'>
              Let&apos;s work together!
            </Balloon>
            <p className='mt-8 max-w-[34ch] text-lead'>
              Send a Figma file, a link to your site or a few lines about the idea. I&apos;ll reply within a
              few hours with a plan and an honest estimate.
            </p>
            <div className='mt-6 flex flex-wrap items-center gap-3'>
              <a href={`mailto:${EMAIL}`} className='btn'>
                Email me <Icon name='right' />
              </a>
              <CopyEmail />
            </div>
          </div>
        </div>
      </div>
      <div className='lg:col-span-5'>
        <EmailForm />
      </div>
    </div>

    <div className='panel mt-tier flex flex-col gap-4 p-4 md:flex-row md:items-center md:justify-between md:px-5'>
      <ul className='lettering flex flex-wrap gap-x-6 gap-y-2 text-[1.25rem]'>
        {SOCIALS.map((s) => (
          <li key={s.label}>
            <a
              href={s.href}
              target='_blank'
              rel='noreferrer'
              className='inline-flex items-center gap-1 underline-offset-4 hover:underline'
            >
              {s.label} <Icon name='out' className='size-4' />
              <span className='sr-only'> (opens in a new tab)</span>
            </a>
          </li>
        ))}
      </ul>
      <p className='lettering flex flex-wrap gap-x-6 text-ink/75'>
        <Clock />
        <span>© {new Date().getFullYear()} Nikita Yeldynov</span>
      </p>
    </div>

    <p className='mt-10 text-center font-display uppercase text-h3' aria-hidden='true'>
      The end
    </p>
  </footer>
)

export default Contact
